import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

export const RelatedJobsContainer = styled.div`
  padding: ${gutterWidth}px 0 55px;
  background: ${colors.backgroundGrey};
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding: ${gutterWidth * 2}px 0;
  }
`;

export const RelatedJobsWrapper = styled.div`
  max-width: ${maxWidth[3]}px;
  margin: 0 auto;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding: 0 ${gutterWidth}px;
  }
`;
